import { NoSymbolIcon } from "@heroicons/react/24/outline"
import * as React from "react"
import { useRouteError } from "react-router-dom"
import { Sentry } from "./services/sentry"

export default function ErrorPage() {
  const error = useRouteError() as any

  React.useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div id="error-page">
      <div
        className="relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 dark:bg-gray-900 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative transform overflow-hidden rounded-lg bg-white dark:bg-gray-700 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 dark:bg-red-900 sm:mx-0 sm:h-10 sm:w-10">
                  <NoSymbolIcon
                    className="h-6 w-6 text-red-600 dark:text-red-300"
                    aria-hidden="true"
                  />
                </div>
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3
                    className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-200"
                    id="modal-title"
                  >
                    Sorry, an unexpected error has occurred
                  </h3>
                  <div className="mt-3">
                    <pre className="p-4 text-sm rounded bg-gray-200 dark:bg-gray-600 dark:text-gray-200 whitespace-break-spaces">
                      <code>{error.statusMessage || error.message}</code>
                    </pre>
                    <p className="mt-2 text-sm text-gray-700 dark:text-gray-200">
                      Our developers have been notified and will be finding a
                      fix soon. You can try reloading the app.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-5 sm:ml-10 sm:mt-4 sm:flex sm:pl-4">
                <a
                  onClick={() => window.location.reload()}
                  className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:w-auto cursor-pointer"
                >
                  Reload
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
